/* eslint semi:0 */
import BaseView from 'views/BaseView'
import ButtonView from 'views/ButtonView'


export default class SocialButtonsBaseView extends BaseView {

  getSocialButtonView({ text, title, href, target, icon, onclick, children, shouldWrapInLabel, }){
    const buttonViewOpts = {
      href,
      target,
      shouldWrapInLabel,
      children: children || [],
      title: title || `Share via ${ text }`,
      onclick: onclick instanceof Function ? onclick.bind(0, this) : onclick,
      classList: [
        'share-component__btn',
        `share-component__btn--${ icon }`,
      ],
    }
    return ButtonView.create(buttonViewOpts)
  }

  getSocialButtonViews(){
    const { ctrl, } = this
    const buttonConfs = ctrl.vm.getVisibleButtons()
    return buttonConfs
      .map(this.getSocialButtonView, this)
      .filter(Boolean)
      .map(socialButtonView => socialButtonView.view(ctrl))
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/socialButtons/SocialButtonsBaseView.js